<section id="funcionalidades" class="section">
	<div class="container">
		<h2>Funcionalidades reales para talleres y servicios técnicos</h2>
		<p class="section-lead">
			Basado en la lógica del sistema NETiC: módulos conectados que simplifican toda la operación de reparación.
		</p>

		<div class="feature-grid">
			<article class="feature-item"><h3>Gestión de órdenes de trabajo</h3><p>Organizá cada reparación con estados, fechas y responsables.</p></article>
			<article class="feature-item"><h3>Gestión de clientes</h3><p>Centralizá datos y relación comercial por historial de servicios.</p></article>
			<article class="feature-item"><h3>Vehículos y equipos</h3><p>Administrá autos, celulares, notebooks, tablets y electrodomésticos.</p></article>
			<article class="feature-item"><h3>Seguimiento de reparación</h3><p>Visualizá avances del trabajo para operar con mayor previsibilidad.</p></article>
			<article class="feature-item"><h3>Presupuestos</h3><p>Generá propuestas claras y convertilas en órdenes confirmadas.</p></article>
			<article class="feature-item"><h3>Pagos y recibos</h3><p>Registrá cobros y emití comprobantes para mantener la caja ordenada.</p></article>
			<article class="feature-item"><h3>Historial de servicios</h3><p>Accedé a antecedentes completos por cliente y por equipo.</p></article>
			<article class="feature-item"><h3>Tablero operativo</h3><p>Medí actividad y detectá cuellos de botella con datos concretos.</p></article>
			<article class="feature-item"><h3>Operación multi-rubro</h3><p>Una plataforma adaptable para distintos negocios de reparación.</p></article>
		</div>
	</div>
</section>
